<template>
  <div>
    <el-button style="width:100%;" type="secondary" size="small" @click="open">서비스맵 설정</el-button>
    <w-sliding-popup ref="slidingPopup" title="서비스맵 설정" top="50px" width="400px" @close="close">
      <div slot="content">
        <div class="mr-b25">
          <!-- Tree -->
          <div :class="['lnb-nav', $style.h100]" v-loading="loading">
            <!-- 검색 영역 -->
            <div class="search">
              <w-search-field @search="filterTree"/>
            </div>
            <!-- 검색 영역 끝 -->
            <article :class="['category-item', $style['tree-h']]">
              <el-scrollbar class="tree-wrapper topologymap-tree" style="padding: 20px 0px 20px 0px">
                <el-tree
                :class="['map-tree', $style.tree]"
                style="height:100%;"
                ref="mapTree"
                :data="treeData"
                :props="treeProps"
                :node-key="treeProps.treeKey"
                :expand-on-click-node="true"
                :filter-node-method="filterNode"
                highlight-current
                :default-checked-keys="checkedKeys"
                :default-expand-all = "true"
                :check-strictly = "true"
                show-checkbox
                @node-click="clickNode">
                  <span class="el-tree-node__label" slot-scope="{ node, data }">
                    <span class="tree-node-edit-icon tree-edit-btn" style="margin-right:5px;">
                      <i class="fas fa-pen active"></i>
                    </span>
                    <el-popover placement="right" trigger="hover" @show="showMapPreview(node)" :open-delay="500" :visible-arrow="false" :popper-class="$style['preview-popup']">
                      <div v-loading="previewLoading" :class="$style['preview-wrapper']">
                        <div v-if="previewLoading"></div>
                        <span v-else-if="!previewImgSrc" :class="$style['no-preview']">미리보기 없음</span>
                        <img v-else :src="previewImgSrc" :class="$style['preview-img']"/>
                      </div>
                      <div slot="reference" class="preview-ref"></div>
                    </el-popover>
                    <span>{{data.label}}</span>
                  </span>
                </el-tree>
              </el-scrollbar>
            </article>
          </div>
          <!-- Tree End -->
        </div>
      </div>
      <div slot="footer">
        <el-button type="solid" size="large" @click="onSaveButtonClick">저장</el-button>
        <el-button size="large" @click="close">취소</el-button>
      </div>
    </w-sliding-popup>
  </div>
</template>

<script>
import { forEach, cloneDeep } from 'lodash';
import msgUtil from '@/utils/message';
import MapAPI from '@/api/topologymap/common';
import WSearchField from '@/components/form/SearchField';
import ServiceApi from '@/api/performance/service/service';

export default {
  name: 'WServiceMapSettingButton',
  components: {
    WSearchField,
  },
  props: {
    objInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      originGetNodes: [],
      originMapIds: [],
      mapInfoList: [],
      loading: false,
      treeData: null,
      isEdit: false,
      previewImgSrc: null,
      previewLoading: false,
      treeProps: {
        treeKey: 'mapId',
        children: 'children',
        label: 'label',
      },
      checkedKeys: [],
    };
  },
  methods: {
    open() {
      this.treeData = [];
      this.checkedKeys = [];
      this.$refs.slidingPopup.visible = true;
      this.loadData();
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.changedFlag = false;
    },
    loadData() {
      this.loading = true; // 로딩 표시
      // 해당 서비스의 mapId 조회
      ServiceApi.getServiceMapInfoList({ objId: this.objInfo.obj.objId }).then((res) => {
        if (res.data.success) {
          this.mapInfoList = res.data.data;
          forEach(this.mapInfoList, (item) => {
            this.checkedKeys.push(item.mapId);
          });
          this.originMapIds = cloneDeep(this.checkedKeys);
          // map 트리 조회
          MapAPI.getTopologymapTree().then((response) => {
            this.loading = false; // 로딩 숨김
            this.treeData = response.data.children;
          });
        }
      });
    },
    onSaveButtonClick() {
      const targetMapIds = [];
      forEach(this.$refs.mapTree.getCheckedNodes(), (item) => {
        targetMapIds.push(item.mapId);
      });
      // set parameters
      const params = {
        deleteMapIds: this.compareArray(this.originMapIds, targetMapIds),
        insertMapIds: this.compareArray(targetMapIds, this.originMapIds),
      };
      ServiceApi.setServiceMapInfoList(params).then((res) => {
        if (res.data.success) {
          this.$message(msgUtil.getCustomResultMsgData('저장이 완료되었습니다.', true));
          this.close();
        } else {
          this.$message(msgUtil.getCustomResultMsgData('저장이 실패하였습니다.', false));
        }
      });
    },
    /**
     * 두개의 mapId 배열을 비교하며 서비스단에서 필요한 key로 각각 묶어서 새로운 리스트를 만든다.
     * 서비스맵 탭 표출 판단용
     * @author Song
     */
    compareArray(standardArr, compareArr) {
      const resultValue = [];
      forEach(standardArr, (item) => {
        if (compareArr.indexOf(item) < 0) {
          const params = {
            serviceId: this.objInfo.obj.objId,
            mapId: item,
          };
          resultValue.push(params);
        }
      });
      return resultValue;
    },
    filterTree(value) {
      this.$refs.mapTree.filter(value);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    clickNode() {
      // 노드 클릭이벤트 - checked
    },
    showMapPreview(mouseoverNode) {
      this.previewLoading = true;
      this.previewImgSrc = null;

      MapAPI.getMapPreview(mouseoverNode.data.mapId).then((response) => {
        const result = response.data;

        if (result.success && result.data) {
          this.previewImgSrc = `data:image/png;base64,${result.data}`;
        }

        this.previewLoading = false;
      });
    },
    handleNodeDrop(draggingNode, droppedNode, dropType) {
      if (dropType && dropType === 'inner') {
        draggingNode.data.parentMapId = droppedNode.data.mapId;
        draggingNode.data.mapRoot = '0';
      } else if (dropType === 'after' || dropType === 'before') {
        draggingNode.data.parentMapId = -1;
        draggingNode.data.mapRoot = '1';
      }
    },
  },
};
</script>
<style lang="scss">
.map-tree {
  .el-tree-node.is-focusable {
    display: block;
    .el-tree-node__content {
      display: block;
    }
  }
  .el-tree-node__content {
    position: relative;
    .el-tree-node__expand-icon {
      z-index: 1;
      position: relative;
    }
  }
  .tree-edit-btn {
    display: none;
  }

  .preview-ref {
    position: absolute;
    left: 0;
    top: 0;
    width: calc(100% - 20px);
    height: 100%;
    z-index: 0;
    .el-icon-edit {
      display: none;
    }
    &:hover {
      .el-icon-edit {
        position: absolute;
        height: inherit;
        right: 0;
        display: inline-flex;
        align-items: center;
      }
    }
    &:focus {
      outline: 0px solid transparent;
    }
  }
}
</style>
<style module>
.h100 {
  height: 100%;
}
.tree-h {
  /* padding: 0 0 0 20px; */
  height: calc(100% - 36px);
}
.preview-popup {
  width: 250px;
  height: 150px;
  background: rgba(208,213,223,0.8);
  border-radius: 3px;
  padding: 7px;
  display: table;
}
.preview-wrapper {
  width: 100%;
  height: 100%;
  border: solid 1px #bdc2cc;
  border-bottom: solid 1px #abafb8;
  display: flex;
}
.preview-img {
  width: 250px;
  height: 150px;
}
.no-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #434d6b;
  font-weight: 500;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/ServiceMapSettingButton.vue